import {FC, SyntheticEvent, useState} from 'react';
import {Box, Tab, Tabs, Typography} from '@mui/material';
import {langSelectWrapperSx, signInSx, tabsSx, tabSx, welcomeBlockSx, wrapperSx,} from './SignUp.sx';
import {LangSelect} from '../../components/common/LangSelect';
import {FormattedMessage, useIntl} from 'react-intl';
import {Link} from 'react-router-dom';
import {SignUpFormForIndividualUser} from 'src/components/forms/SignUpFormForIndividualUser';
import {AppRouteEnum, AppRouteSpace} from 'src/utils/helper';
import {TabPanel} from 'src/components/common/TabPanel';
import {SignUpFormForCorporateUser} from 'src/components/forms/SignUpFormForCorporateUser';

export const SignUp: FC = () => {
    const intl = useIntl();
    const [tab, setTab] = useState(0);

    const handleTab = (_event: SyntheticEvent, newValue: number) => {
        setTab(newValue);
    };

    const isActiveTab = (selectedTabNumber: number, currentTabNumber: number) => {
        return selectedTabNumber === currentTabNumber;
    };

    return (
        <Box sx={wrapperSx}>
            <Box sx={langSelectWrapperSx}>
                <LangSelect/>
            </Box>
            <Box sx={welcomeBlockSx}>
                <Typography
                    variant="h1"
                    color="textPrimary"
                >
                    <FormattedMessage id="signUpToAMP"/>
                </Typography>
                <Box sx={signInSx}>
                    <Typography
                        variant="subtitle1"
                        color="grey.500"
                    >
                        <FormattedMessage id="aMember"/>
                    </Typography>
                    <Link to={AppRouteSpace([AppRouteEnum.login])}>
                        <Typography
                            variant="subtitle1"
                            color="primary"
                        >
                            <FormattedMessage id="signIn"/>
                        </Typography>
                    </Link>
                </Box>

                <Tabs
                    sx={tabSx}
                    value={tab}
                    onChange={handleTab}
                >
                    <Tab
                        sx={tabsSx(isActiveTab(tab, 0), 0)}
                        label={intl.formatMessage({id: 'signUpTabIndividualUser'})}
                    />
                    <Tab
                        sx={tabsSx(isActiveTab(tab, 1), 1)}
                        label={intl.formatMessage({id: 'signUpTabCorporateUser'})}
                    />
                </Tabs>

                <TabPanel
                    value={tab}
                    index={0}
                >
                    <SignUpFormForIndividualUser/>
                </TabPanel>
                <TabPanel
                    value={tab}
                    index={1}
                >
                    <SignUpFormForCorporateUser/>
                </TabPanel>
            </Box>
        </Box>
    );
};
